__turbopack_context__.v({
  "className": "oe3QGa_className",
  "variable": "oe3QGa_variable",
});
